module.exports = __webpack_public_path__ + "img/done_white_24dp.0db08473.svg";